var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "div",
        { staticClass: "modal-popup", on: { click: _vm.handleOverlayClick } },
        [
          _c(
            "div",
            {
              staticClass: "popup two-factor-popup",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _vm.connected
                ? _c("div", { staticClass: "two-factor-success" }, [
                    _c("div", { staticClass: "success-icon" }, [_vm._v("✓")]),
                    _c("h4", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("onboarding.2fa.success_title") ||
                            "Connexion réussie !"
                        )
                      ),
                    ]),
                    _vm.analysts && _vm.analysts.length
                      ? _c("p", { staticClass: "analysts-warning" }, [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("dash.bots.analysts")) +
                              " " +
                              _vm._s(_vm.analysts.join(", ")) +
                              "\n      "
                          ),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "buttons" }, [
                      _c(
                        "div",
                        {
                          staticClass: "button btn-primary",
                          on: { click: _vm.closeSuccess },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("onboarding.2fa.continue") || "Continuer"
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]),
                  ])
                : _vm.page && _vm.twoFactorInfo
                ? _c("div", { staticClass: "two-factor-form" }, [
                    _c("div", { staticClass: "page-header" }, [
                      _c("div", { staticClass: "page-avatar" }, [
                        _vm.page.avatar
                          ? _c("img", {
                              attrs: {
                                src: _vm.page.avatar,
                                alt: _vm.page.name,
                              },
                            })
                          : _c(
                              "div",
                              { staticClass: "page-avatar-placeholder" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.page.name
                                        ? _vm.page.name[0].toUpperCase()
                                        : "?"
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                      ]),
                      _c("h4", [_vm._v(_vm._s(_vm.page.name))]),
                    ]),
                    _c("div", { staticClass: "two-factor-instructions" }, [
                      _vm.twoFactorInfo.verification_method == 0
                        ? _c("p", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t("onboarding.2fa.method_app") ||
                                    "Veuillez renseigner ci-dessous le code de vérification reçu sur l'application vous permettant d'effectuer vos authentifications à deux facteurs :"
                                ) +
                                "\n        "
                            ),
                          ])
                        : _vm.twoFactorInfo.verification_method == 1
                        ? _c("p", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t("onboarding.2fa.method_sms") ||
                                    "Veuillez renseigner ci-dessous le code de vérification reçu par SMS :"
                                ) +
                                "\n        "
                            ),
                          ])
                        : _vm.twoFactorInfo.verification_method == 4
                        ? _c("p", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t("onboarding.2fa.method_push") ||
                                    "Veuillez accepter l'appareil depuis la notification envoyée par votre application Instagram :"
                                ) +
                                "\n          "
                            ),
                            _c("br"),
                            _vm.page.story_config &&
                            _vm.page.story_config.user_agent
                              ? _c("strong", [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.page.story_config.user_agent.split(
                                          ";"
                                        )[4]
                                      ) +
                                      "\n          "
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _vm.twoFactorInfo.verification_method == 90
                        ? _c("p", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t("onboarding.2fa.method_email_sms") ||
                                    "Veuillez entrer le code reçu par Email ou SMS :"
                                ) +
                                "\n          "
                            ),
                            _c("br"),
                            _c("small", { staticClass: "method-note" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "onboarding.2fa.method_experimental"
                                    ) ||
                                      "(Cette méthode de vérification est en cours de test et peut rencontrer des difficultés)"
                                  ) +
                                  "\n          "
                              ),
                            ]),
                          ])
                        : _vm.twoFactorInfo.verification_method == 99
                        ? _c("p", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t("onboarding.2fa.method_push_or_sms") ||
                                    "Veuillez accepter l'appareil depuis la notification Instagram ou entrer le code reçu par SMS :"
                                ) +
                                "\n          "
                            ),
                            _c("br"),
                            _c("small", { staticClass: "method-note" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "onboarding.2fa.method_leave_empty"
                                    ) ||
                                      "(Si vous recevez une notification, laissez le champ vide)"
                                  ) +
                                  "\n          "
                              ),
                            ]),
                          ])
                        : _vm.twoFactorInfo.verification_method == 98
                        ? _c("p", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t("onboarding.2fa.method_linkedin") ||
                                    "Veuillez entrer le code reçu par Email ou SMS :"
                                ) +
                                "\n        "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm.twoFactorInfo.verification_method != 4
                      ? _c("div", { staticClass: "two-factor-input" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.verificationCode,
                                expression: "verificationCode",
                              },
                            ],
                            staticClass: "code-input",
                            attrs: {
                              type: "number",
                              placeholder:
                                _vm.$t("onboarding.2fa.code_placeholder") ||
                                "Code de vérification",
                              autofocus: "",
                            },
                            domProps: { value: _vm.verificationCode },
                            on: {
                              keypress: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.submitCode.apply(null, arguments)
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.verificationCode = $event.target.value
                              },
                            },
                          }),
                        ])
                      : _vm._e(),
                    _vm.errorMessage
                      ? _c("p", { staticClass: "error-message" }, [
                          _vm._v(_vm._s(_vm.errorMessage)),
                        ])
                      : _vm._e(),
                    _vm.infoMessage
                      ? _c("p", { staticClass: "info-message" }, [
                          _vm._v(_vm._s(_vm.infoMessage)),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "buttons" }, [
                      _c(
                        "div",
                        {
                          staticClass: "button btn-outline-primary",
                          on: { click: _vm.cancel },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("onboarding.2fa.cancel") || "Annuler"
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "button btn-primary",
                          class: { loading: _vm.isSubmitting },
                          attrs: { disabled: _vm.isSubmitDisabled },
                          on: { click: _vm.submitCode },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.isSubmitting
                                  ? _vm.$t("onboarding.2fa.connecting") ||
                                      "Connexion..."
                                  : _vm.$t("onboarding.2fa.connect") ||
                                      "Connecter"
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]),
                    _vm.twoFactorInfo.verification_method == 98
                      ? _c("div", { staticClass: "resend-section" }, [
                          _c("p", { staticClass: "resend-text" }, [
                            _vm._v(_vm._s(_vm.$t("dash.pages.linkedin_code"))),
                          ]),
                          _c(
                            "button",
                            {
                              staticClass: "resend-button",
                              on: { click: _vm.resendCode },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t("dash.pages.linkedin_code_btn") ||
                                      "Renvoyer le code"
                                  ) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _c("div", { staticClass: "two-factor-error" }, [
                    _c("h4", [
                      _vm._v(
                        _vm._s(_vm.$t("onboarding.2fa.error_title") || "Erreur")
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("onboarding.2fa.error_no_page") ||
                            "La page n'existe pas ou n'a pas besoin d'authentification à deux facteurs."
                        )
                      ),
                    ]),
                    _c("div", { staticClass: "buttons" }, [
                      _c(
                        "div",
                        {
                          staticClass: "button btn-primary",
                          on: { click: _vm.cancel },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("onboarding.2fa.close") || "Fermer"
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]),
                  ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }